import axios from 'axios';
import config from '@custom/core/config/config';
import { FeedData } from '../types';

const fetchData = async () => {
  const apiUrl = config.api.live;
  let response = {} as FeedData;
  try {
    const { data } = await axios({
      method: 'GET',
      url: apiUrl,
    });
    if (data) {
      response = data as FeedData;
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export { fetchData };
